import { render } from "./mockup.vue?vue&type=template&id=0a683114"
import script from "./mockup.vue?vue&type=script&lang=js"
export * from "./mockup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__